var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCartIcon = function SvgCartIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 46.13 40.599",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4739",
    "data-name": "Path 4739",
    d: "M569.2,799.162h24.241a1.337,1.337,0,0,0,1.285-.969l5.346-18.713a1.337,1.337,0,0,0-1.285-1.7h-32.67l-.955-4.3a1.337,1.337,0,0,0-1.305-1.047h-8.02a1.337,1.337,0,0,0,0,2.673h6.948l4.826,21.717a4.009,4.009,0,0,0,1.593,7.689h24.237a1.337,1.337,0,0,0,0-2.673H569.208a1.336,1.336,0,0,1,0-2.673Zm27.815-18.713-4.583,16.039H570.28l-3.564-16.039Z",
    transform: "translate(-554.505 -772.429)",
    fill: "#707070",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4740",
    "data-name": "Path 4740",
    d: "M612.028,914.5a4.01,4.01,0,1,0,4.01-4.01A4.015,4.015,0,0,0,612.028,914.5Zm4.01-1.336A1.337,1.337,0,1,1,614.7,914.5,1.338,1.338,0,0,1,616.038,913.159Z",
    transform: "translate(-598.662 -878.407)",
    fill: "#707070",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4741",
    "data-name": "Path 4741",
    d: "M693.328,914.5a4.01,4.01,0,1,0,4.01-4.01A4.015,4.015,0,0,0,693.328,914.5Zm4.01-1.336A1.337,1.337,0,1,1,696,914.5,1.338,1.338,0,0,1,697.338,913.159Z",
    transform: "translate(-661.071 -878.407)",
    fill: "#707070",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCartIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cart-icon.361e45ce.svg";
export { ForwardRef as ReactComponent };